import {
  OPEN_SUBSCRIPTION_POPUP,
  CLOSE_SUBSCRIPTION_POPUP,
} from "GlobalActionTypes/SubscriptionPopup";

export const openSubscriptionPopup = (modelId, makeName, modelName) => {
  return {
    type: OPEN_SUBSCRIPTION_POPUP,
    data: {
      modelId: modelId,
      makeName: makeName,
      modelName: modelName,
    },
  };
};

export const closeSubscriptionPopup = () => {
  return {
    type: CLOSE_SUBSCRIPTION_POPUP,
  };
};
